import { IPropertyCard, IPropertyListRequest } from '@/components/templates/search/interfaces';
import {
	CaseReducer,
	createAsyncThunk,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { STATUS } from '../globalContext/globalContext.interfaces';
import { IPropertyContext } from '../globalContext/propertiesContext.interface';
import { IThunkApiExtra, RootState } from '../store';


type State = IPropertyContext

export const initialState: State = {
	page: 1,
	results: [],
	total: 0,
	status: STATUS.init,
	message: undefined
}

export const fetchByCriteria = createAsyncThunk<State, IPropertyListRequest, { extra: IThunkApiExtra}>(
	'properties/fetchByCriteria',
	async (request: IPropertyListRequest | undefined, thunkApi) => {
		// https://www.w3docs.com/snippets/javascript/how-to-encode-javascript-object-to-query-string.html
		// const requestAsQuery = new URLSearchParams(request as any).toString();
		const { rejectWithValue, extra } = thunkApi
		if (request === undefined) return rejectWithValue("Se necesita información para buscar propiedades");
		const { services } = extra;
		const servicesList = (await services()).setupServices()
		
		// const response = await fetch(`${apiEndpoint}/properties?${requestAsQuery ?? "page=1"}`)
		// Inferred return type: Promise<MyData>
		// Metodo de obtencion de propiedades anterior
		// return (await servicesList.getProperties(request)) as State
		return (await servicesList.getPropiedades(request)) as State
	}
)

const setResultsReducer: CaseReducer<State, PayloadAction<IPropertyCard[]>> = (state, action) =>
{
	state.results = action.payload
}

const setTotalReducer: CaseReducer<State, PayloadAction<number>> = (state, action) =>
{
	state.total = action.payload
}

const setStatusToIdleReducer: CaseReducer<State> = (state) =>
{
	state.status = STATUS.idle
}

export const PropertiesSlice = createSlice({
	name: 'properties',
	initialState,
	reducers: {
		setResults: setResultsReducer,
		setTotal: setTotalReducer,
		setStatusToIdle: setStatusToIdleReducer
	},
	extraReducers: builder => {
		builder.addCase(fetchByCriteria.pending, (state, action) => {
			state.status = STATUS.pending;
			state.lastRequestId = action.meta.requestId;
		})
		builder.addCase(fetchByCriteria.fulfilled, (state, action) => {
			const { results, total, page, message } = action.payload;
			state.results = results;
			state.total = total;
			state.message = message;
			// state.page = page;
			state.status = message !== undefined ? STATUS.error : STATUS.idle
		})
		builder.addCase(fetchByCriteria.rejected, (state, action) => {
			state.status = STATUS.error;
			state.message = action.error ? action.error.message: "Ha ocurrido un error";
		})
	}
})

export const { setResults, setTotal, setStatusToIdle } = PropertiesSlice.actions;

export const selectPropertiesResult = (state: RootState) => state.PropertyState.results;
export const selectPropertiesPage = (state: RootState) => state.PropertyState.page;
export const selectPropertiesCount = (state: RootState) => state.PropertyState.total;
export const selectPropertiesStatus = (state: RootState) => state.PropertyState.status;